/* KidCollective Search Modal */
(function(){
  const modal = document.getElementById('kc-search-modal');
  const overlay = document.getElementById('kc-search-overlay');
  const toggleBtn = document.getElementById('kc-search-toggle');
  const closeBtn = document.getElementById('kc-search-close');
  const searchInput = document.getElementById('kc-search-input');
  
  const defaultView = document.getElementById('kc-search-default');
  const resultsView = document.getElementById('kc-search-results');
  
  const recentWrap = document.getElementById('kc-recent-searches-wrap');
  const recentContainer = document.getElementById('kc-recent-searches-container');
  const clearRecentBtn = document.getElementById('kc-clear-recent');

  const RECENT_KEY = 'kc_recent_views';

  // Toggle Modal
  function openSearch(){ 
    modal.classList.add('open'); 
    overlay.classList.add('open'); 
    document.body.style.overflow = 'hidden'; 
    renderRecent();
    setTimeout(() => searchInput.focus(), 100);
  }
  function closeSearch(){ 
    modal.classList.remove('open'); 
    overlay.classList.remove('open'); 
    document.body.style.overflow = ''; 
  }

  if(toggleBtn) toggleBtn.addEventListener('click', openSearch);
  if(closeBtn) closeBtn.addEventListener('click', closeSearch);
  if(overlay) overlay.addEventListener('click', closeSearch);

  // --- Recent Products Logic ---
  function getRecent(){ 
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } 
    catch(e){ return []; } 
  }
  
  function saveRecent(items){ 
    localStorage.setItem(RECENT_KEY, JSON.stringify(items)); 
  }
  
  function addRecent(product){
    let items = getRecent();
    items = items.filter(i => i.id !== product.id); // Remove if exists to move to top
    items.unshift(product);
    if(items.length > 10) items = items.slice(0, 10); // keep max 10
    saveRecent(items);
  }
  
  function removeRecent(id){
    let items = getRecent();
    items = items.filter(i => i.id !== id);
    saveRecent(items);
    renderRecent();
  }

  function renderRecent(){
    if(!recentWrap || !recentContainer) return;
    const items = getRecent();
    if(items.length === 0){
      recentWrap.style.display = 'none';
      return;
    }
    
    recentWrap.style.display = 'block';
    recentContainer.innerHTML = '';
    
    items.forEach(item => {
      const div = document.createElement('div');
      div.className = 'kc-search-card';
      div.innerHTML = `
        <button type="button" class="kc-recent-remove" data-id="${item.id}" aria-label="Remove">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <a href="${item.url}" class="kc-search-card-link kc-log-click" data-prod='${JSON.stringify(item)}'>
          <div class="kc-search-card-img"><img src="${item.image}" alt="${item.title}" loading="lazy"></div>
          <div class="kc-search-card-info">
            <p class="kc-search-card-title">${item.title}</p>
            <div class="kc-search-card-price">
              ${item.compare ? `<span class="compare">${item.compare}</span>` : ''}
              <span class="sale">${item.price}</span>
            </div>
          </div>
        </a>
      `;
      recentContainer.appendChild(div);
      
      div.querySelector('.kc-recent-remove').addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        removeRecent(this.dataset.id);
      });
    });
  }

  if(clearRecentBtn){
    clearRecentBtn.addEventListener('click', () => {
      saveRecent([]);
      renderRecent();
    });
  }

  // --- Click Tracking for ANY product link inside modal ---
  document.addEventListener('click', function(e){
    const link = e.target.closest('.kc-search-card-link');
    if(!link) return;
    
    // Check if it has data attrs for recommended products
    if(link.dataset.prodId){
      addRecent({
        id: link.dataset.prodId,
        title: link.dataset.prodTitle,
        price: link.dataset.prodPrice,
        compare: link.dataset.prodCompare,
        image: link.dataset.prodImage,
        url: link.getAttribute('href')
      });
    } 
    // Or if it was injected via predictive search / recent search with JSON data
    else if(link.dataset.prod){
      addRecent(JSON.parse(link.dataset.prod));
    }
  });

  // --- Predictive Search Logic ---
  let searchTimer;
  if(searchInput){
    searchInput.addEventListener('input', function(){
      clearTimeout(searchTimer);
      const query = this.value.trim();
      
      if(query.length === 0){
        defaultView.style.display = 'block';
        resultsView.style.display = 'none';
        return;
      }
      
      searchTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`)
          .then(r => r.json())
          .then(data => {
            const products = data.resources.results.products;
            if(!products || products.length === 0){
              resultsView.innerHTML = `<div class="kc-search-section-header"><h3>No results found for "${query}"</h3></div>`;
            } else {
              let html = `<div class="kc-search-section-header"><h3>Search Results</h3></div><ul class="kc-predictive-list">`;
              products.forEach(p => {
                const itemData = JSON.stringify({ id: p.id, title: p.title, price: p.price, compare: p.compare_at_price, image: p.image, url: p.url });
                html += `
                  <li class="kc-search-card">
                    <a href="${p.url}" class="kc-search-card-link" data-prod='${itemData}'>
                      <div class="kc-search-card-img"><img src="${p.image}" alt="${p.title}" loading="lazy"></div>
                      <div class="kc-search-card-info">
                        <p class="kc-search-card-title">${p.title}</p>
                        <div class="kc-search-card-price"><span class="sale">${p.price}</span></div>
                      </div>
                    </a>
                  </li>
                `;
              });
              html += `</ul>`;
              html += `<div style="text-align:center; margin-top:30px;"><a href="/search?q=${encodeURIComponent(query)}&type=product" class="kc-btn kc-btn-outline">View All Results</a></div>`;
              resultsView.innerHTML = html;
            }
            defaultView.style.display = 'none';
            resultsView.style.display = 'block';
          });
      }, 400);
    });
  }

})();
